export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EnsembleCard.vue?vue&type=template&id=1b527a4e"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EnsembleCard.vue?vue&type=template&id=1b527a4e
// module id = 385
// module chunks = 0